import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Section, Eyebrow } from "@/components/PublicLayout";

export default function Scholarships() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/scholarships").then((r) => setItems(r.data)); }, []);
  return (
    <Section className="py-16 md:py-24">
      <Eyebrow>Scholarships &amp; aid</Eyebrow>
      <h1 className="font-serif text-4xl md:text-6xl tracking-tight text-ink">Support that is real, not advertised.</h1>
      <p className="mt-5 max-w-2xl text-ink/65 leading-relaxed">Additional aid is only shown as available when a funded budget exists. Financial documents are collected securely, and financial-aid review can be separated from the admissions decision.</p>
      <div className="mt-12 grid md:grid-cols-2 gap-px bg-border border border-border">
        {items.map((s) => (
          <div key={s.slug} className="bg-paper p-7" data-testid={`scholarship-${s.slug}`}>
            <div className="flex items-center gap-2">
              <span className="font-mono text-xs uppercase text-heraldic">{s.type}</span>
              {!s.funded && <span className="text-xs text-ink/40 border border-border px-2 py-0.5 rounded-sm">subject to funded budget</span>}
            </div>
            <div className="mt-2 font-serif text-2xl text-ink">{s.name_en}</div>
            <div className="mt-1 text-heraldic text-sm">{s.value_en}</div>
            <p className="mt-3 text-ink/65 leading-relaxed text-sm">{s.eligibility_en}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}
